import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';

import { propertyByIdSelector } from 'state/properties/properties.selectors';
import { addPropertyAdminRoutine } from 'state/properties/properties.routines';

import Page from 'components/page/page.component';

import AddPropertyForm from 'components/add-property-form/add-property-form.component';

const AddProperty = ({ history }) => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { property } = useSelector(propertyByIdSelector(id));

    const handleSubmit = (values) => {
        dispatch(addPropertyAdminRoutine.trigger(values));
    };

    const handleSuccess = () => {
        if (history) history.push('/admin/properties');
    };

    return (
        <Page noHero pageContentStyle={{ minHeight: '800px', width: '100%', padding: 0 }}>
            <AddPropertyForm onSubmit={handleSubmit} onSuccess={handleSuccess} property={property} />
        </Page>
    );
};

export default withRouter(AddProperty);
